import gql from 'graphql-tag';
import { List } from 'immutable';

import GraphQLClient from '../../adapter/GraphQLClient';
import GoogleAdAccount from '../../entity/GoogleAdAccount';
import { handleGoogleError } from './GoogleWebApi';

class GoogleAdWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getAllIntegratedAdAccounts = async (organizationId: string): Promise<List<GoogleAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query integratedGoogleAdAccounts($organizationId: ID!) {
            integratedGoogleAdAccounts(organizationId: $organizationId) {
              id
              googleAccountId
              name
              thumbnailUrl
            }
          }
        `,
        { organizationId },
      );
      const items = result.integratedGoogleAdAccounts as GoogleAdAccount[];
      return List(items);
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };

  // 連携可能なGoogle Ads Accountsの一覧が返る
  public registerGoogleTokenWithAdwordsScope = async (
    authCode: string,
    organizationId: string,
  ): Promise<List<GoogleAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation registerGoogleTokenWithAdwordsScope($authCode: ID!, $organizationId: ID!) {
            registerGoogleTokenWithAdwordsScope(authCode: $authCode, organizationId: $organizationId) {
              id
              googleAccountId
              name
              thumbnailUrl
            }
          }
        `,
        { authCode, organizationId },
      );
      const items = result.registerGoogleTokenWithAdwordsScope as GoogleAdAccount[];
      return List(items);
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };

  public integrateAdAccount = async (
    googleAdAccount: GoogleAdAccount,
    organizationId: string,
  ): Promise<GoogleAdAccount> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation integrateGoogleAdAccount($googleAdAccount: GoogleAdAccountInput!, $organizationId: ID!) {
            integrateGoogleAdAccount(googleAdAccount: $googleAdAccount, organizationId: $organizationId)
          }
        `,
        { googleAdAccount, organizationId },
      );
      return result.integrateGoogleAdAccount;
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };

  public revokeAdAccount = async (accountId: string, organizationId: string): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation revokeGoogleAdAccount($accountId: ID!, $organizationId: ID!) {
            revokeGoogleAdAccount(accountId: $accountId, organizationId: $organizationId)
          }
        `,
        { accountId, organizationId },
      );
      return result.revokeGoogleAdAccount;
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };
}

export default GoogleAdWebApi;
